module.exports = __webpack_public_path__ + "Open_Sans-normal-700.72862e7cf19603ad24f2.woff";


//////////////////
// WEBPACK FOOTER
// ./~/inspinia/dist/Open_Sans-normal-700.woff
// module id = 903
// module chunks = 2